import { ADMIN_PREFIX } from "@cti-workspace/helpers";
import { getApi } from "./api";

export default async function GetDatabaseConnections() {
	const url = `/${ADMIN_PREFIX}/listDatabaseConnections/`;
	return getApi(url);
}
